import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Handles Firebase Auth action URLs (password reset, email verification, etc.)
 * Redirects to appropriate pages based on the action mode
 */
export default function FirebaseActionHandler() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const mode = searchParams.get('mode');
    const oobCode = searchParams.get('oobCode');
    const apiKey = searchParams.get('apiKey');

    if (mode === 'resetPassword' && oobCode) {
      // Redirect to our custom reset password page with the oobCode
      navigate(`/reset-password?oobCode=${encodeURIComponent(oobCode)}${apiKey ? `&apiKey=${encodeURIComponent(apiKey)}` : ''}`, { replace: true });
    } else if (mode === 'verifyEmail' && oobCode) {
      // Handle email verification if needed
      // For now, just show a message or redirect to login
      navigate('/login?emailVerified=true', { replace: true });
    } else {
      // Unknown action or missing parameters
      navigate('/login', { replace: true });
    }
  }, [navigate, searchParams]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-amber-50 via-amber-100 to-amber-200 flex items-center justify-center p-6">
      <div className="bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl w-full max-w-md p-8 border border-amber-200">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Processing your request...</p>
        </div>
      </div>
    </div>
  );
}


